import { IconStorage } from "@app/shared/icons/interfaces";

export const minus: IconStorage = {
  svgCode: () => ([
    "M5 12H19"
  ]),
};
